export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Vest_Roughness.5a177ee8.tga";